import { clsx } from "@trydig/ui";
import type { ComponentProps } from "react";
import { Skeleton } from "@/components/ui/Skeleton";
import {
	RetailerLocation,
	RetailerLocationSkeleton,
} from "./components/RetailerLocation";
import styles from "./Retailer.module.css";

export type RetailerProps = Omit<ComponentProps<"article">, "children"> & {
	name: string;
	street: string;
	city: string;
	country: string;
	postalCode: string;
	website?: string;
	phone?: string;
	coordinates?: [number, number];
	isActive?: boolean;
	variant?: "default" | "popup";
};

export const Retailer = ({
	name,
	street,
	city,
	country,
	postalCode,
	website,
	phone,
	isActive,
	className,
	coordinates,
	variant,
	...rest
}: RetailerProps) => {
	return (
		<article
			className={clsx(
				styles.root,
				variant === "popup" && styles.popup,
				className,
			)}
			data-is-active={isActive}
			{...rest}
		>
			{variant !== "popup" && <RetailerLocation coordinates={coordinates} />}
			<div className={styles.info}>
				<span className={styles.name}>{name}</span>
				<div className={styles.address}>
					<span>{street}</span>
					<span>
						{postalCode}, {city}
					</span>
					<span>{country}</span>
				</div>
				<div className={styles.contact}>
					<a href={`tel:${phone}`} target="_blank" rel="noreferrer">
						{phone}
					</a>
					<a href={website} target="_blank" rel="noreferrer">
						{website}
					</a>
				</div>
			</div>
		</article>
	);
};

export const RetailerSkeleton = () => {
	return (
		<article className={styles.root}>
			<RetailerLocationSkeleton />
			<div className={styles.info}>
				<Skeleton fitContent>
					<span className={styles.name}>Lorem ipsum dolor sit amet.</span>
				</Skeleton>
				<div className={styles.address}>
					<Skeleton fitContent>
						<span>Lorem ipsum dolor.</span>
					</Skeleton>
					<Skeleton fitContent>
						<Skeleton>xxxx, xxxx</Skeleton>
					</Skeleton>
					<Skeleton fitContent>
						<span>Lorem ipsum.</span>
					</Skeleton>
				</div>
				<div className={styles.contact}>
					<Skeleton fitContent>
						<span>0000-0000-0000</span>
					</Skeleton>
					<Skeleton fitContent>
						<span>https://example.com</span>
					</Skeleton>
				</div>
			</div>
		</article>
	);
};
